<template>
  <div class="admin-screen">
    <md-tabs class="md-transparent" @change="onChange" ref="tabs">
      <md-tab id="customers" :md-active="activeTab === 0" :md-label="trDepots">
        <customer-list
          :editId="(activeTab === 0) ? editId : undefined"
          :create="create === 0"
          @changeTab="changeTab"
        ></customer-list>
      </md-tab>

      <md-tab id="users" :md-active="activeTab === 1" :md-label="trUsers">
        <user-list
          :editId="(activeTab === 1) ? editId : undefined"
          :create="create === 1"
        ></user-list>
      </md-tab>

      <md-tab id="products" :md-active="activeTab === 2" :md-label="trProducts">
        <product-list
          :editId="(activeTab === 2) ? editId : undefined"
          :create="create === 2"
        ></product-list>
      </md-tab>

      <md-tab id="product-lists" :md-active="activeTab === 3" :md-label="trProductLists">
        <product-list-list
          :editId="(activeTab === 3) ? editId : undefined"
          :create="create === 3"
        ></product-list-list>
      </md-tab>

      <md-tab id="orders" :md-active="activeTab === 4" :md-label="trOrders" ref="tab4">
        <order-list></order-list>
      </md-tab>
    </md-tabs>

  </div>
</template>

<script>
import Vue from 'vue'
import CustomerList from './customers/List'
import UserList from './users/List'
import ProductList from './products/List'
import ProductListList from './product-lists/List'
import OrderList from './orders/List'

export default {
  name: 'dashboard',
  data () {
    return {
      // local copies of props to avoid mutating props directly
      idLocal: undefined,
      createLocal: undefined
    }
  },
  created () {
    this.idLocal = this.editId
    this.createLocal = this.create
  },
  props: ['activeTab', 'editId', 'create'],
  watch: {
    activeTab (val, oldVal) {
      // when the tab is changed, the editId and created values are discarded (the form is closed)
      if (val !== oldVal) {
        this.idLocal = undefined
        this.createLocal = undefined
      }
      this.onChange(val)
    }
  },
  computed: {
    trDepots () {
      return this.$gettext('Depots')
    },
    trUsers () {
      return this.$gettext('Users')
    },
    trProducts () {
      return this.$gettext('Products')
    },
    trProductLists () {
      return this.$gettext('Product Lists')
    },
    trOrders () {
      return this.$gettext('Orders')
    }
  },
  methods: {
    onChange (value) {
      if (this.createLocal !== undefined) {
        this.$router.push({ name: 'tab-' + value + '-create' })
      } else if (this.idLocal !== undefined) {
        this.$router.push({ name: 'tab-' + value + '-edit', params: { id: this.idLocal } })
      } else {
        this.$router.push({ name: 'tab-' + value })
      }

      // looks like this solves the problem with TAB not being updated immediately after change of language
      Vue.nextTick(() => {
        this.$refs.tabs.$forceUpdate()
      })
    },
    changeTab (prodListName) {
      // change the tab to clicked Product List (in Customers menu)
      this.onChange(3)
      this.$store.commit('productListEdit', prodListName)
    }
  },
  components: {
    CustomerList,
    UserList,
    ProductList,
    ProductListList,
    OrderList
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/Dashboard.vue